import React from 'react';
import '../styles/ErrorPage.css'; // optional styling

const NotFound: React.FC = () => {
  return (
    <div className="error-page">
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <a href="/">Return to Home</a>
    </div>
  );
};

export default NotFound;